module.exports = __webpack_public_path__ + "static/media/gainza.9f9a9a63.jpg";